"use client";

import dynamic from "next/dynamic";
import type { ComponentProps } from "react";

type HeroMusicV2Props = ComponentProps<typeof import("./HeroMusicV2").HeroMusicV2>;

const HeroMusicV2Client = dynamic<HeroMusicV2Props>(() => import("./HeroMusicV2").then(mod => mod.HeroMusicV2));

export function HeroMusicV2Lazy(props: HeroMusicV2Props) {
  return <HeroMusicV2Client {...props} />;
}
